import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import { PannellumSceneType } from '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import { createHotspot } from './hotspot/Hotspot.js';
import { useMultiResConfig } from './multiresStore.js';

const identifyDevice = () => {
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)) {
        return "tablet";
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent)) {
        return "mobile";
    }
    else {
        return "desktop";
    }
};
const getPanoramaImagePath = (url, lowResolutionUrl = "") => {
    return (identifyDevice() === "mobile" && lowResolutionUrl) || url;
};
const getPannellumHotSpot = ({ hotspot, sceneId, relatedContext, helpers, brandingColor, infospot, }) => {
    const { _id, rotation } = hotspot;
    return Object.assign(Object.assign({ id: _id }, rotation), { createTooltipFunc: createHotspot, createTooltipArgs: {
            hotspot,
            relatedContext,
            sceneId,
            helpers,
            brandingColor,
            infospot,
        } });
};
const getMultiResImagePath = (url) => {
    return url === null || url === void 0 ? void 0 : url.split("/").slice(0, -1).join("/");
};
const getPannellumSceneConfig = ({ node, isMultires, isHorizonLevel, relatedContext: context, helpers, brandingColor, staged, }) => {
    var _a, _b, _c, _d, _e;
    if (!node) {
        return {};
    }
    const type = (isMultires && PannellumSceneType.multires) || PannellumSceneType.equirectangular;
    const sceneId = node._id;
    const relatedContext = Object.assign(Object.assign({}, context), { node });
    const sceneHotspots = (_a = node.nodeLinks) === null || _a === void 0 ? void 0 : _a.map((nodeLink) => getPannellumHotSpot({ hotspot: nodeLink, sceneId: sceneId, relatedContext, helpers, brandingColor }));
    const infospots = (_b = node.infospots) === null || _b === void 0 ? void 0 : _b.map((infospot) => getPannellumHotSpot({
        hotspot: infospot,
        sceneId: sceneId,
        relatedContext,
        helpers,
        brandingColor,
        infospot: true,
    }));
    const photo = (staged && node.stagedPhoto) || node.photo;
    const scene = {
        name: node.label,
        hfov: (document.documentElement.clientWidth < document.documentElement.clientHeight && 80) || 115,
        horizonPitch: (isHorizonLevel && ((_c = node.rotation) === null || _c === void 0 ? void 0 : _c.pitch)) || 0,
        horizonRoll: (isHorizonLevel && ((_d = node.rotation) === null || _d === void 0 ? void 0 : _d.roll)) || 0,
        nodeId: sceneId,
        relatedContext,
        type,
        imageId: photo === null || photo === void 0 ? void 0 : photo._id,
        yaw: ((_e = node.rotation) === null || _e === void 0 ? void 0 : _e.yaw) || 0,
        hotSpots: [...sceneHotspots, ...infospots],
    };
    if (type === PannellumSceneType.multires) {
        const multiResConfigObj = useMultiResConfig.getState().getConfig(node);
        scene.multiRes = Object.assign({ basePath: getMultiResImagePath(photo === null || photo === void 0 ? void 0 : photo.multiResConfigUrl) }, multiResConfigObj);
    }
    else {
        scene.panorama = getPanoramaImagePath(photo === null || photo === void 0 ? void 0 : photo.url, photo === null || photo === void 0 ? void 0 : photo.lowResUrl);
    }
    return scene;
};
const getNodeById = (nodes, nodeId) => {
    if (nodes && nodes.length) {
        return nodes.find((node) => node._id === nodeId);
    }
};
const getStartNodeId = (nodes, startNodeId) => {
    var _a;
    if (nodes && nodes.length) {
        return startNodeId ? ((_a = nodes.find((node) => node._id === startNodeId)) === null || _a === void 0 ? void 0 : _a._id) || nodes[0]._id : nodes[0]._id;
    }
};

export { getMultiResImagePath, getNodeById, getPannellumHotSpot, getPannellumSceneConfig, getPanoramaImagePath, getStartNodeId, identifyDevice };
